module.exports = __webpack_public_path__ + "static/media/logo.25ec5e11.png";